import { memo } from 'react';
import { Control } from 'react-hook-form';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import FormRowTestResult from './FormRowTestResult';
import { IFormData } from './FormTestResult';
import Td from './Td';

type Collection = {
  fieldName: string;
  isError: boolean;
  isTextArea?: boolean;
  message: string | undefined;
  colSpan?: number;
};
type RowData = {
  mainLabel?: MessageDescriptor;
  label: MessageDescriptor;
  collections: Collection[];
  rowSpan?: number;
  display?: boolean;
};
export type FormRowTestResultProps = {
  control: Control<IFormData>;
  rowDataList: RowData[];
};

const FormSectionTestResult: React.FC<FormRowTestResultProps> = ({
  control,
  rowDataList,
}) => {
  return (
    <>
      {rowDataList
        ?.filter((row: RowData) => row.display)
        ?.map((row: RowData, indexRow) => (
          <tr key={indexRow}>
            {row?.rowSpan && (
              <Td rowSpan={row?.rowSpan} width="18%">
                <strong>
                  <FormattedMessage {...row?.mainLabel} />
                </strong>
              </Td>
            )}
            <Td>
              <FormattedMessage {...row?.label} />
            </Td>
            {row?.collections?.map((item: Collection, index) => (
              <Td
                key={index}
                colSpan={item?.colSpan ? item?.colSpan : undefined}
              >
                <FormRowTestResult
                  isInvalid={!!item.isError}
                  error={item?.message}
                  fieldName={item?.fieldName}
                  control={control}
                  isTextArea={item?.isTextArea}
                />
              </Td>
            ))}
          </tr>
        ))}
    </>
  );
};

export default memo(FormSectionTestResult);
